/**
 * Theme colors for Booking Management pages (Edit Booking, Booking Details).
 * Matches BookingDetailsPage: rgba(22, 67, 135, 1)
 */
export const THEME_PRIMARY = "rgba(22, 67, 135, 1)";
export const THEME_PRIMARY_HOVER_BG = "rgba(22, 67, 135, 0.05)";
export const THEME_PRIMARY_LIGHT = "rgba(22, 67, 135, 0.7)";
export const THEME_PRIMARY_TINT = "rgba(22, 67, 135, 0.08)";
